
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxTrading.css';

const RedboxTrading = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Trading - Advanced Trading Tools & Market Execution | Redbox Global</title>
        <meta
          name="description"
          content="Redbox Trading delivers advanced trading tools, real-time execution, analytics, and market access for professional traders and institutions."
        />
        <meta
          name="keywords"
          content="Redbox Trading, trading platform, market execution, trading tools, equities trading, FX trading, derivatives trading"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/trading" />
        <meta property="og:title" content="Redbox Trading - Advanced Trading Platform" />
        <meta
          property="og:description"
          content="Execute trades with confidence using Redbox Trading’s professional-grade tools and real-time market access."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Redbox Trading - Professional Trading Platform" />
        <meta
          name="twitter:description"
          content="Advanced execution, analytics, and trading tools with Redbox Trading."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=1200&h=630&fit=crop"
        />

        <link rel="canonical" href="https://redboxglobal.com/trading" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Redbox Trading",
            "applicationCategory": "FinanceApplication",
            "operatingSystem": "Web",
            "description":
              "Professional trading platform offering real-time execution, analytics, and market access.",
            "url": "https://redboxglobal.com/trading",
            "publisher": {
              "@type": "Organization",
              "name": "Redbox Global"
            }
          })}
        </script>
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Redbox Trading</h1>
          <p className="page-subtitle">
            Advanced trading tools, execution, and market access for professionals
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/redbox-trading-overview"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=1200&h=600&fit=crop"
                  alt="Professional trading platform interface"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Trading Platform</span> */}
                <h2>Trade Global Markets with Speed and Precision</h2>
                <p>
                  Redbox Trading empowers professional traders with advanced execution tools,
                  deep liquidity access, and real-time analytics across global asset classes.
                  Execute confidently in fast-moving markets.
                </p>
                <span className="article-meta">Explore Trading</span>
              </div>
            </div>
          </a>

          {/* Article Cards */}
          <div className="content-grid">
            <a
              href="/article/multi-asset-trading"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop"
                    alt="Multi-asset trading"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Multi-Asset</span> */}
                  <h2>Trade Equities, FX, Fixed Income & Derivatives</h2>
                  <p>
                    Access a wide range of asset classes from a single platform with unified
                    workflows and cross-asset analytics.
                  </p>
                  <span className="article-meta">View Markets</span>
                </div>
              </article>
            </a>

            <a
              href="/article/algorithmic-trading"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop"
                    alt="Algorithmic trading"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Automation</span> */}
                  <h2>Algorithmic & Automated Trading Strategies</h2>
                  <p>
                    Build, test, and deploy algorithmic trading strategies using advanced tools
                    and real-time execution infrastructure.
                  </p>
                  <span className="article-meta">Explore Automation</span>
                </div>
              </article>
            </a>

            <a
              href="/article/risk-management"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop"
                    alt="Risk management tools"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Risk</span> */}
                  <h2>Risk Management & Trade Analytics</h2>
                  <p>
                    Monitor exposure, analyze performance, and manage risk in real time with
                    integrated analytics and reporting tools.
                  </p>
                  <span className="article-meta">Manage Risk</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedboxTrading;
